import React from "react"
import { Source, Layer } from "react-map-gl"
import type { BoundaryProps } from "../../types"

const Boundary: React.FC<BoundaryProps> = ({ coordinates }) => {
  if (!coordinates?.length) return null

  const boundaryGeoJSON = {
    type: "Feature",
    geometry: {
      type: "Polygon",
      coordinates: [coordinates],
    },
    properties: {},
  }

  return (
    <Source id="boundaries" type="geojson" data={boundaryGeoJSON}>
      <Layer
        id="boundaries-fill"
        type="fill"
        paint={{
          "fill-color": "hsl(253, 74%, 68%)",
          "fill-opacity": 0.1,
        }}
      />
      <Layer
        id="boundaries-line"
        type="line"
        paint={{
          "line-color": "hsl(253, 74%, 68%)",
          "line-opacity": 0.8,
          "line-dasharray": [4, 3],
          "line-width": 4,
        }}
      />
    </Source>
  )
}

export default React.memo(Boundary)
